import React, { useEffect, useState } from 'react';

import { Translation, getI18n } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import { Button } from 'antd';
import notification from '../../../elements/lib/NotificationWrapper';

const RegisterStep4Form = ({
  cognitoId,
  cognitoKey,
  profileId,
  newUserRequirement,
  cognitoFormId,
  careGuideId,
  ...props
}) => {
  const [redirectTo, setRedirectTo] = useState(null);

  const handleSkip = () => {
    props.create(careGuideId, { cognito_form_id: cognitoFormId }, (success) => {
      if (success) {
        notification.success(getI18n().t('skip_cognito_form_success'));
      } else {
        notification.error(getI18n().t('skip_cognito_form_error'));
      }
    });

    setRedirectTo(
      pathTo(Config.get('DEFAULT_REGISTRATION_REDIRECT'), null, {
        rct: 'step4',
      })
    );
  };

  useEffect(() => {
    if (!cognitoId || !cognitoKey) return;

    const script = document.createElement('script');
    script.src = 'https://www.cognitoforms.com/f/seamless.js';
    script.dataset.key = cognitoKey;
    script.dataset.form = cognitoId;
    script.async = true;

    script.onload = () => {
      if (window.Cognito) {
        window.Cognito.mount(cognitoId, '#cognito')
          .prefill({
            UserProfileId: profileId,
            CognitoFormId: cognitoFormId,
          })
          .on('afterSubmit', function (e) {
            setRedirectTo(
              pathTo(Config.get('DEFAULT_REGISTRATION_REDIRECT'), null, {
                rct: 'step4',
              })
            );
          });
      }
    };
    document.getElementById('cognito').appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cognitoId, cognitoKey]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <Translation>
      {(t) => (
        <div className='register-form-register-form-step4'>
          <div style={{ backgroundColor: 'white', padding: '10px' }}>
            <div id='cognito'></div>
            {newUserRequirement === 2 && (
              <div style={{ width: '100%' }}>
                <Button type='default' size='large' block onClick={handleSkip}>
                  {t('register_screen_step4_skip')}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </Translation>
  );
};

export default RegisterStep4Form;
